import { render, staticRenderFns } from "./myCart.vue?vue&type=template&id=14821dd2"
import script from "./myCart.vue?vue&type=script&lang=js"
export * from "./myCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports